import { render } from "./ProductInfo.vue?vue&type=template&id=1a207faa&scoped=true&ts=true"
import script from "./ProductInfo.vue?vue&type=script&lang=ts"
export * from "./ProductInfo.vue?vue&type=script&lang=ts"

import "./ProductInfo.vue?vue&type=style&index=0&id=1a207faa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a207faa"]])

export default __exports__